import { motion } from 'framer-motion'
import { ArrowRight, Coffee } from 'lucide-react'

const CtaSection = () => {
  const scrollToContact = () => {
    const element = document.querySelector('#kapcsolat')
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' })
    }
  }

  return (
    <section className="py-24 md:py-32 bg-coffee-900 relative overflow-hidden">
      {/* Background decorations */}
      <div className="absolute inset-0 pointer-events-none">
        <motion.div
          className="absolute top-10 left-10 w-32 h-32 bg-coffee-800/50 rounded-full blur-3xl"
          animate={{ scale: [1, 1.2, 1], opacity: [0.3, 0.5, 0.3] }}
          transition={{ duration: 8, repeat: Infinity }}
        />
        <motion.div
          className="absolute bottom-10 right-10 w-40 h-40 bg-coffee-700/30 rounded-full blur-3xl"
          animate={{ scale: [1.2, 1, 1.2], opacity: [0.3, 0.5, 0.3] }}
          transition={{ duration: 10, repeat: Infinity }}
        />
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="text-center max-w-3xl mx-auto">
          <motion.div
            className="inline-flex items-center gap-2 bg-coffee-800 text-coffee-200 px-4 py-2 rounded-full text-sm mb-8"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
          >
            <Coffee size={16} />
            Ingyenes konzultáció
          </motion.div>

          <motion.h2
            className="font-heading text-4xl md:text-5xl lg:text-6xl font-bold text-cream mb-6"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.1 }}
          >
            Indítsuk be a{' '}
            <span className="relative inline-block">
              vállalkozásod
              <motion.span
                className="absolute bottom-1 left-0 right-0 h-2 bg-coffee-600/60"
                initial={{ scaleX: 0 }}
                whileInView={{ scaleX: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: 0.5 }}
              />
            </span>
          </motion.h2>

          <motion.p
            className="text-xl text-coffee-200 mb-10 leading-relaxed"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.2 }}
          >
            Készen állsz, hogy több ügyfeled és bevételed legyen? 
            Kezdjük egy kötetlen beszélgetéssel!
          </motion.p>

          <motion.div
            className="flex flex-col sm:flex-row gap-4 justify-center"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.3 }}
          >
            <button
              onClick={scrollToContact}
              className="group inline-flex items-center justify-center gap-2 bg-cream text-coffee-900 px-10 py-4 rounded-full font-semibold text-lg hover:bg-coffee-100 transition-all duration-300 shadow-lg"
              data-testid="cta-section-primary"
            >
              Kérj ajánlatot
              <ArrowRight size={20} className="group-hover:translate-x-1 transition-transform duration-200" />
            </button>
            <a
              href="tel:+36301234567"
              className="inline-flex items-center justify-center gap-2 border-2 border-coffee-600 text-cream px-10 py-4 rounded-full font-semibold text-lg hover:bg-coffee-800 transition-all duration-300"
              data-testid="cta-section-phone"
            >
              +36 30 123 4567
            </a>
          </motion.div>

          <motion.p
            className="mt-8 text-coffee-400 text-sm"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ delay: 0.5 }}
          >
            Válaszolok 24 órán belül minden megkeresésre
          </motion.p>
        </div>
      </div>
    </section>
  )
}

export default CtaSection
